module.exports = __webpack_public_path__ + "static/media/cloud-bg-1.235ff2fd.png";